export { GovernancePage as default } from '@/components/enpages/Ir/Governance'
